import React, { useEffect } from "react";
import InstructionDefault from "./instructionPages/default/InstructionDefault";
import { useProfile } from "../../context/ProfileContext";
import { useQuestion } from "../../context/QuestionsContext";
import { useLanguages } from "../../context/LanguagesContext";
import { useAttemptedQuestions } from "../../context/AttemptedQuestionsContext";
import InstructionsPageIpMat from "./instructionPages/ipmat/InstructionsPageIpMat";
import { decryptData } from "../../crypto";

function Instruction() {
  const { fetchProfileData } = useProfile();
  const { fetchQuestions } = useQuestion();
  const { fetchLanguagesData } = useLanguages();
  const { fetchAttemptedQuestions } = useAttemptedQuestions();

  useEffect(() => {
    fetchProfileData();
  }, []);

  useEffect(() => {
    const examId = sessionStorage.getItem("examId");
    if (examId) {
      fetchQuestions(examId);
      fetchLanguagesData(examId);
      fetchAttemptedQuestions(examId);
    }
  }, []);

  const type = decryptData(sessionStorage.getItem("exam_template"));

  const componentMap = {
    iit: <InstructionDefault />,
    default: <InstructionDefault />,
    ipmat: <InstructionsPageIpMat />,
  };

  return componentMap[type] || <InstructionDefault />;
}

export default Instruction;
